var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.paragraphs),function(p,i){return _c('p',{key:i},[_vm._v(_vm._s(p))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }